<div *ngIf="loading" class="d-flex justify-content-center">
    <mat-spinner diameter="100"></mat-spinner>
</div>

<app-splash-screen></app-splash-screen>
<div [hidden]="loading">
    <router-outlet></router-outlet>
</div>
